import React, { useEffect, useState } from 'react';

import Loader from '../Shared/Loader';
import { FILTER_GLOBAL_KEYS, FILTER_KEYS, LEAGUES } from '../../config/constants';
import GameTable from './Tables/GameTable';
import { useRouter } from '../../helpers/customHooks';
import { getTeamProps, isNCAA } from '../../helpers';
import {
  useFiltersState,
  useGamesDispatch,
  useGamesState,
  useTablePropertiesDispatch,
  useUserState
} from '../../store/hooks';

export default () => {

  const user = useUserState();
  const games = useGamesState();
  const { loadGames } = useGamesDispatch();
  const { specificScope, pathname } = useRouter();
  const { changeOrderColumn: changeTablePropertiesOrderColumn } = useTablePropertiesDispatch();
  const {
    [FILTER_GLOBAL_KEYS.WEEKS]: weeks,
    [FILTER_KEYS.TEAM_ID]: filterTeamIdData,
    [FILTER_KEYS.DATE_RANGE]: filterDateRangeData
  } = useFiltersState(specificScope, FILTER_KEYS.TEAM_ID, FILTER_KEYS.DATE_RANGE, FILTER_GLOBAL_KEYS.WEEKS);

  const [modal, setModal] = useState<JSX.Element | null>(null);
  const [currentLeague, setCurrentLeague] = useState(LEAGUES.NFL);


  useEffect(() => {
    const isNCAATeamAdmin = isNCAA(user);
    const isTeamPerformance = pathname.split('/')[1] === 'team';
    if (
      weeks &&
      ((isTeamPerformance || isNCAATeamAdmin) || (!isTeamPerformance && !isNCAATeamAdmin && filterTeamIdData)) &&
      (filterDateRangeData && filterDateRangeData.selectedDates && filterDateRangeData.selectedDates.length)
    ) {
      loadGames();
    }
  }, [weeks, filterTeamIdData, filterDateRangeData]);

  useEffect(() => {
    const { league } = getTeamProps(filterTeamIdData) || getTeamProps(user.teamId) ||{} as { league: string };
    if (league) {
      setCurrentLeague(league);
      const orderColumn = league === LEAGUES.NFL ? -3 : -2;
      changeTablePropertiesOrderColumn(orderColumn);
    }
    /* teamId parameter 'cause each time a team changes a request is made on the filters */
  }, [filterTeamIdData]);

  return (
    <Loader forceLoader={!weeks}>
      {modal}
      <GameTable
        games={games}
        setModal={setModal}
        league={currentLeague}
      />
    </Loader>
  );
}
;
